﻿import {ITemplateModel} from "../../Model/Template/ITemplateModel";
import {IDisposableLike} from "../../Tools/Disposable/IDisposableLike";
import {Preview} from "../../Controller/Process/Preview";

export class TemplatePreview implements IDisposableLike {
    #jqMainContainer: JQuery | undefined;
    #model: ITemplateModel | undefined;
    #jqContainer: JQuery | undefined;
    #jqIframe: JQuery | undefined;
    #jqTextContent: JQuery | undefined;

    constructor(options: ITemplateHtmlPreviewOption) {
        this.#jqMainContainer = options.jqMainContainer;
        this.#model = options.model;
    }

    public Init = () => {
        this.#buildHtml();
        this.#loadPreview()
    }

    #buildHtml = () => {
        
        this.#jqContainer = $("<div></div>")
            .css({width: "100%", height: "100%"})
            .appendTo(this.#jqMainContainer);

        switch (this.#model.TypeContent) {
            case  0:
                this.#buildTextContent();
                break;
            case 1:
                this.#buildIFrame();
                break
            default:
                throw new Error("Type de contenu inconnu");
        }
    }

    #buildIFrame = () => {
        this.#jqIframe = $("<iframe></iframe>")
            .css({width: "100%", height: "100%", margin: 0, padding: 0, border: 0, overflowY: "auto"})
            .appendTo(this.#jqContainer);
    }

    #buildTextContent = () => {
        this.#jqTextContent = $("<textarea disabled></textarea>")
            .css({width: "100%", height: "100%", margin: 0, padding: 0, border: 0, overflowY: "auto"})
            .appendTo(this.#jqContainer);
    }

    #loadPreview = () => {
        const m = JSON.parse(JSON.stringify(this.#model)) as ITemplateModel;
        m.Datas.forEach((v) => {
            v.Code = v.Code.replace(/\\r\\n/g, '')
                .replace(/\\n/g, '')
                .replace(/\\r/g, '');

            console.log(v.Code);
        })

        Preview.Read(m).then((result: string) => { 
            switch (this.#model.TypeContent) {
                case 0:
                    this.#jqTextContent.val(result);
                    break;
                case 1:
                    this.#jqIframe.attr("srcdoc", result);
                    break;
                default:
                    throw new Error("Type de contenu inconnu");
            }
        });
    }

    public Dispose = () => {
        
        this.#jqContainer?.remove();
        this.#jqMainContainer.empty();
    }
}

export interface ITemplateHtmlPreviewOption {
    jqMainContainer: JQuery;
    model: ITemplateModel
}